import React, { useEffect } from 'react'

import { useAuth } from 'src/modules/auth'
import { SecondaryNavLayout } from 'src/modules/ui'
import { useActionRunner } from 'src/modules/notification'

import { useSuppliers } from '../hooks'
import ProductView from './ProductView'
import SuppliersView from './SuppliersView'
import SingleSupplierView from './SingleSupplierView'

export const mapSectionToNav = section => {
  const sections = {
    starred: 'favourites',
    with_proposals: 'proposals',
    approved: 'approved',
  }
  return sections[section] || 'find'
}

const Suppliers = () => {
  const {
    fetchAllergenFilterChoices,
    fetchCategoryChoices,
    fetchDietaryFilterChoices,
    fetchSustainabilityFilterChoices,
  } = useSuppliers()
  const { hasPermission } = useAuth()

  const [fetchData] = useActionRunner([
    fetchAllergenFilterChoices,
    fetchDietaryFilterChoices,
    fetchCategoryChoices,
    fetchSustainabilityFilterChoices,
  ])

  useEffect(() => {
    fetchData()
  }, [])

  const routes = []

  if (hasPermission('source_suppliers')) {
    routes.push(
      ...[
        {
          navLabel: 'Find Suppliers',
          path: `/suppliers/${mapSectionToNav()}`,
          render: props => <SuppliersView {...props} />,
        },
        {
          navLabel: 'Favourites',
          path: `/suppliers/${mapSectionToNav('starred')}`,
          render: props => <SuppliersView {...props} section="starred" />,
        },
        {
          navLabel: 'With Proposals',
          path: `/suppliers/${mapSectionToNav('with_proposals')}`,
          render: props => (
            <SuppliersView {...props} section="with_proposals" />
          ),
        },
      ]
    )
  }

  routes.push(
    ...[
      {
        navLabel: 'Approved Suppliers',
        path: `/suppliers/${mapSectionToNav('approved')}`,
        render: props => <SuppliersView {...props} section="approved" />,
      },
      {
        path: '/suppliers/:id/',
        component: SingleSupplierView,
        title: 'Supplier',
      },
      {
        path: '/products/:id/',
        component: ProductView,
        title: 'Product',
      },
    ]
  )

  return <SecondaryNavLayout routes={routes} />
}
export default Suppliers
